import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { useSelector } from 'react-redux'
import {Typography} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import {fetchPrivileges} from "./actions/privilegeActions";
import _ from 'lodash';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/core/SvgIcon/SvgIcon";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import UserService from "./Services/UserService";
import showSnackBar from "./Utilities/SnackbarHelper";
import {ERROR, SUCCESS, WARNING} from "./constants";
import { useSnackbar } from 'notistack';
import {useDebounce} from "use-debounce";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        // height: '50vh'
    },
    input: {
        minWidth: 200,
        width: 300,
    },
    userManagerCard:{
        // minHeight:'25rem',
        // minWidth:'25rem'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
        width: 290,
    },
    bccEmailsDisplay: {

    }
}));

export default function UserManager(props) {

    const classes = useStyles();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [values, setValues] = React.useState({});
    const [userData, setUserData] = React.useState();
    const [cpUserData, setCpUserData] = React.useState();

    // const updateForEntityDebounced = useDebounce(values.updateForEntity,1000);



    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    const userToolAccessFlag = useSelector(state =>
    {
        let flag = false;
        let privileges = state.privilege.privileges;
        if(privileges && privileges.length>0){
            _.forEach(privileges,(privilege)=>{
                if(privilege.name === "User Tool"){
                    flag = true
                }});
        }
        return flag;
    });

    const validate = (values)=>{
        let valid = true;
        values.forEach(value=>{
            if( (value == null) || (value == undefined) ){
                valid = false
            }else{
                if(value){
                    value = value.trim();
                }
                if(value == ""){
                    valid = false;
                }
            }
        });
        return valid;
    };

    const updateUserPassword = (event)=>{
        event.preventDefault();

        let isValid = validate([values.username,values.password]);

        if(isValid){
            let self = this;
            let body = {
                updateBy: 'Username',
                updateForEntity: values.username,
                updateAttribute: 'password',
                updateValue: values.password,
                requester: sessionStorage.userEmail
            };

            UserService.updateUserAttribute(body).then((response)=>{
                let userServiceResponse = response.data;
                let message = "";
                message = `Password updated successfully!`;

                enqueueSnackbar(message,{
                    variant: SUCCESS, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            },(error)=>{
                enqueueSnackbar(`Failed to update Password.`,{
                    variant: SUCCESS, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            })
        }else {
            enqueueSnackbar(`Invalid input.`,{
                variant: WARNING, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }
            });
        }

    };

    const updateNotificationEmail = (event)=>{
        event.preventDefault();

        let isValid = validate([values.cpUsername,values.cpUserEmail]);

        if(isValid){
            let self = this;
            let body = {
                updateBy: 'Username',
                updateForEntity: values.cpUsername,
                updateAttribute: 'appendingBccEmail',
                updateValue: values.cpUserEmail,
                requester: sessionStorage.userEmail
            };

            UserService.updateUserAttribute(body).then((response)=>{
                let userServiceResponse = response.data;
                let message = "";
                message = `Ingestion Notification Email added successfully!`;

                enqueueSnackbar(message,{
                    variant: SUCCESS, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });

                getCpUserData();
            },(error)=>{
                enqueueSnackbar(`Failed to add ingestion notification email.`,{
                    variant: SUCCESS, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            })
        }else {
            enqueueSnackbar(`Invalid input.`,{
                variant: WARNING, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }
            });
        }

    };

    const getUserData = ()=>{
        setUserData();
        let entity = values.username;
        let parameterString = "";
        parameterString = `?username=${entity}`;

        UserService.getUserData(parameterString).then((response)=>{
            let userData = response.data;
            if(response.data && response.data.status === "SUCCESS" && response.data.user){
                setUserData(response.data.user);
            }else{
                enqueueSnackbar(`No user found for username : ${values.username}`,{
                    variant: WARNING, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            }
        },(error)=>{

        })
    };

    const getCpUserData = ()=>{
        setCpUserData();
        let entity = values.cpUsername;
        let parameterString = "";
        parameterString = `?username=${entity}`;

        UserService.getUserData(parameterString).then((response)=>{
            let userData = response.data;
            if(response.data && response.data.status === "SUCCESS" && response.data.user){
                setCpUserData(response.data.user);
            }else{
                enqueueSnackbar(`No user found for username : ${values.cpUsername}`,{
                    variant: WARNING, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            }
        },(error)=>{

        })
    };


    return (
        <React.Fragment>
            {/* {userToolAccessFlag===true && */}
                <Grid container direction="row"
                       justify="flex-start"
                       alignContent="flex-start">
                    <Grid item xs={1}></Grid>
                    <Grid item xs={4}>
                        <form autoComplete="off" onSubmit={updateUserPassword.bind(this)}>
                            <Card className={classes.userManagerCard}>

                                <CardHeader title={"Update User Password"}></CardHeader>
                                <CardContent>
                                    <Grid direction="row" justify="center"
                                          container spacing={0}>

                                        <Grid xs={12}>

                                            <TextField fullWidth
                                                       id="title" required
                                                       label={'Username'}
                                                       className={classes.input}
                                                       onChange={handleChange('username')}
                                                       value={values.username}
                                                       margin="normal"
                                            />

                                            {values && values.username && values.username.length > 2 &&
                                            <>
                                                <br/>
                                                <Button variant={"outlined"} onClick={getUserData}>Get Details</Button>
                                                <br/>
                                            </>
                                            }

                                            <br/>
                                            {userData && userData.name && values.username &&
                                            <Typography variant={"body2"} className={classes.bccEmailsDisplay}>
                                                Role:
                                                {userData.roleName || "Not found"}
                                            </Typography>
                                            }

                                            {userData && values.username &&
                                            <TextField fullWidth
                                                       id="title" required
                                                       label={"Password"}
                                                       className={classes.input}
                                                       onChange={handleChange('password')}
                                                       value={values.password}
                                                       margin="normal"
                                            />}

                                        </Grid>
                                    </Grid>

                                    {userData && values.username &&
                                    <CardActions>
                                        <Button variant="contained" type="submit" color="primary"
                                                className={classes.button}>
                                            Save
                                        </Button>
                                    </CardActions>
                                    }
                                </CardContent>

                            </Card>
                        </form>
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={4}>
                        <form autoComplete="off" onSubmit={updateNotificationEmail.bind(this)}>
                            <Card className={classes.userManagerCard}>

                                <CardHeader title={"Add Ingestion Notification Email"}></CardHeader>
                                <CardContent>
                                    <Grid direction="row" justify="center"
                                          container spacing={0}>

                                        <Grid item xs={12}>
                                            <TextField fullWidth
                                                       id="title" required
                                                       label={"Username"}
                                                       className={classes.input}
                                                       onChange={ handleChange('cpUsername')}
                                                       value={values.cpUsername}
                                                       margin="normal"
                                            />

                                            {values && values.cpUsername && values.cpUsername.length > 2 &&
                                            <>
                                                <br/>
                                                <Button variant={"outlined"} onClick={getCpUserData}>Get Details</Button>
                                                <br/>
                                            </>
                                            }

                                            <br/>
                                            {cpUserData && cpUserData.name && values.cpUsername &&
                                            <>
                                                <Typography variant={"body2"}>
                                                    Role : {cpUserData.roleName || `Not found`}
                                                </Typography>
                                                {cpUserData.bccemail && cpUserData.bccemail != "" && (cpUserData.roleName==="partner") &&
                                                <div className={classes.bccEmailsDisplay}>
                                                    {cpUserData.bccemail && cpUserData.bccemail != "" &&
                                                    _.map(_.split(cpUserData.bccemail, ','), (emailId) => {
                                                        return <Chip variant="outlined" size="small"
                                                                     label={emailId}/>
                                                    })
                                                    ||
                                                    " None"
                                                    }
                                                </div>}
                                                {cpUserData.roleName && (cpUserData.roleName !== "partner") &&
                                                <Typography variant={"body2"}>
                                                    Ingestion Notifications can only be added to a CP with "Partner" role.
                                                </Typography>
                                                }
                                            </>
                                            }

                                            {cpUserData && values.cpUsername && (cpUserData.roleName==="partner") &&
                                            <TextField fullWidth
                                                       id="title" required
                                                       label={"Add Notification Email"}
                                                       className={classes.input}
                                                       type={"email"}
                                                       onChange={handleChange('cpUserEmail')}
                                                       value={values.cpUserEmail}
                                                       margin="normal"
                                            />}

                                        </Grid>
                                    </Grid>

                                    {cpUserData && values.cpUsername  && (cpUserData.roleName==="partner") &&
                                    <CardActions>
                                        <Button variant="contained" type="submit" color="primary"
                                                className={classes.button}>
                                            Save
                                        </Button>
                                    </CardActions>
                                    }

                                </CardContent>

                            </Card>
                        </form>
                    </Grid>
                    <Grid item xs={1}></Grid>
                </Grid>

            {/* } */}
        </React.Fragment>
    );
}